module.exports = __webpack_public_path__ + "img/20201213_133409.8f2e0b4e.jpg";